import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-p-2 content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslationListView = _resolveComponent("TranslationListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.documentClassTranslationFilter)
      ? (_openBlock(), _createBlock(_component_TranslationListView, {
          key: _ctx.documentClassTranslationFilter,
          fixedFilter: _ctx.documentClassTranslationFilter
        }, null, 8, ["fixedFilter"]))
      : _createCommentVNode("", true)
  ]))
}